import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import { PSE_FLOWS_OPTIONS } from "../../utils/productionStepExecution"

const sx = {
    icon: {
        width: "24px",
        height: "24px",
        padding: "8px",
        borderRadius: "64px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    container: {
        borderRadius: "4px",
        border: "0.8px solid #DBDBDB",
        padding: "12px 16px",
        width: "100%",
        gap: "12px",
    },
    label: {
        color: "#262626",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px"
    }
}

const Labels = () => {
    return (
        <Box className="flexRow center" sx={sx.container}>
            {Object.values(PSE_FLOWS_OPTIONS).map((type, index) => (
                <Stack key={type + index} direction="row" alignItems="center" spacing={1}>
                    <Box sx={{ ...sx.icon, backgroundColor: type.color }}>
                        <img alt={type.label} src={"/icons/pses/status/" + type.icon + ".svg"} style={{ width: "14px", height: "14px" }} />
                    </Box>
                    <Typography variant="body1" sx={sx.label}>{type.label}</Typography>
                </Stack>
            ))}
        </Box>
    )
}

export default Labels